// File: src/pages/LoginPage.js

import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Toast from '../components/toast';       // ← import Toast
import '../assets/css/LoginPage.css';

import AuthContext from '../context/AuthContext';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, loading } = useContext(AuthContext);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!username.trim() || !password.trim()) {
      setError('Please fill in both fields.');
      return;
    }

    try {
      await login(username.trim(), password.trim());
      setSuccess('Login successful! Redirecting…');
      setTimeout(() => navigate('/dashboard'), 1000);
    } catch (err) {
      console.error('Login failed:', err);
      setError(err.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="login-page-wrapper">
      <Header />

      <main className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <h1 className="login-heading">Admin Login</h1>

          <div className="form-group">
            <label htmlFor="username">Username or Email</label>
            <input
              type="text"
              id="username"
              placeholder="Username or Email"
              value={username}
              onChange={e => setUsername(e.target.value)}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in…' : 'Login'}
          </button>
        </form>
      </main>

      <Footer />

      {/*  Render exactly one toast in the body via Portal */}
      {error   && <Toast type="error">{error}</Toast>}
      {success && <Toast type="success">{success}</Toast>}
    </div>
  );
};

export default LoginPage;
